var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('recently-viewed',{attrs:{"decorator":_vm.filterOnCurrentBrand,"repository":_vm.repository,"brand":_vm.brand}})}
var staticRenderFns = []

export { render, staticRenderFns }